import React from "react";

import { Col, Row, Stack } from "react-bootstrap";

import classNames from "classnames";
import currency from "currency.js";

import { ResaleFragment } from "@api/graphql";
import styles from "@pages/dashboard/DetailsDrawer.module.scss";

import { DetailPriceCell } from "../resale_submission/DetailPriceCell";

interface ResalePriceBreakdownProps {
  resale: ResaleFragment;
}

export const ResalePriceBreakdown: React.FC<ResalePriceBreakdownProps> = ({ resale }) => (
  <Stack gap={4} className="col-md-10">
    <Row>
      <span className={classNames(styles["stack-label"], "h5")}>Resale price breakdown</span>
    </Row>
    <Row>
      <div className={classNames(styles["price-breakdown"])}>
        <Col md={8}>
          <DetailPriceCell title="Royalty payable gross" value={currency(resale.royalty ?? 0).format()} />
          <hr className={styles.breakLine} />
          <DetailPriceCell title="Resale price" value={currency(resale.resale_price ?? 0).format()} isTotal />
        </Col>
      </div>
    </Row>
  </Stack>
);
